import { render, staticRenderFns } from "./tabpage.vue?vue&type=template&id=818f0c06&scoped=true"
import script from "./tabpage.vue?vue&type=script&lang=js"
export * from "./tabpage.vue?vue&type=script&lang=js"
import style0 from "./tabpage.vue?vue&type=style&index=0&id=818f0c06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818f0c06",
  null
  
)

export default component.exports